import React from 'react';
import { motion } from 'framer-motion';
import { FiSearch, FiFilter } from 'react-icons/fi';
import './FilterBar.css';

const FilterBar = ({ filters, onFilterChange }) => {
  return (
    <motion.div
      className="filter-bar"
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
      <div className="container">
        <div className="filter-content">
          {/* Search */}
          <div className="filter-group search-group">
            <div className="search-wrapper">
              <FiSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search casino..."
                value={filters.search}
                onChange={(e) => onFilterChange({ search: e.target.value })}
                className="search-input"
              />
            </div>
          </div>

          {/* Bonus Type */}
          <div className="filter-group">
            <label>
              <FiFilter className="filter-icon" />
              Bonus Type
            </label>
            <select
              value={filters.bonusType}
              onChange={(e) => onFilterChange({ bonusType: e.target.value })}
              className="filter-select"
            >
              <option value="all">All Types</option>
              <option value="welcome">Welcome Bonus</option>
              <option value="deposit">Deposit Bonus</option>
              <option value="freespins">Free Spins</option>
              <option value="cashback">Cashback</option>
              <option value="nodeposit">No Deposit</option>
            </select>
          </div>

          {/* Min Bonus */}
          <div className="filter-group">
            <label>Min. Bonus</label>
            <select
              value={filters.minBonus}
              onChange={(e) => onFilterChange({ minBonus: parseInt(e.target.value) })}
              className="filter-select"
            >
              <option value="0">All</option>
              <option value="50">$50+</option>
              <option value="100">$100+</option>
              <option value="200">$200+</option>
              <option value="500">$500+</option>
            </select>
          </div>

          {/* Sort By */}
          <div className="filter-group">
            <label>Sort By</label>
            <select
              value={filters.sortBy}
              onChange={(e) => onFilterChange({ sortBy: e.target.value })}
              className="filter-select"
            >
              <option value="placement">Ranking</option>
              <option value="bonus">Bonus Amount</option>
              <option value="newest">Newest</option>
            </select>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default FilterBar;
